import { useContext, useEffect, useState } from 'react';
import '../classes/styles/style.css';
import Screen from '../components/screen';
import * as WS from '../webServices/cyMyManager'
import Spinner from '../components/spinner';
import Modal from '../components/modal';
import { GlobalContextData, GetGlobalContext } from '../classes/context';
import * as UT from '../classes/utility';
import ActionBtn from '../components/actionBtn';
import TableOrdini from '../mobile-components/tableOrdini';

// interface OrdineTot extends WS.Plus.IF.AbbonamVend { totale: number }

export default function Ordini() {
    const globalContext = useContext<GlobalContextData>(GetGlobalContext);
    const [ordini, setOrdini] = useState<WS.Plus.IF.AbbonamVendTest[] | undefined>(undefined)
    const [modalShow, setModalShow] = useState(false);
    const [ordineSel, setOrdineSel] = useState<WS.Plus.IF.AbbonamVend | undefined>(undefined)
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    const [sedi, setSedi] = useState<WS.Plus.IF.SedeEsercente[] | undefined>(undefined);
    const [filSedeSel, setFilSedeSel] = useState<string | undefined>(undefined)

    const onLoad = async (): Promise<void> => {
        // let listOrd = await WS.Plus.getListaOrdini(WS.UT.TOKEN, 3,globalContext.vars.esercente?.Id ?? 0, 0, "", "", 0, 0);
        let listSedi = await WS.Plus.getListaSediEsercenti(WS.UT.TOKEN, "", globalContext.vars.esercente?.Id ?? 0, 0, 0, 0, 0);

        if (listSedi.isOk) {
            setSedi(listSedi.list);
            setFilSedeSel(listSedi.list[0].Id.toString())
        }

        // let ordiniNew: OrdineTot[] = [];

        // for (let idx = 0; idx < listOrd.list.length; idx++) {
        //     const ord = listOrd.list[idx];

        //     if (ord.IdSedeEserc !== 1 && ord.IdSedeEserc !== 2) continue;

        //     let posNew = ordiniNew.push({ testata: ord, righe: [], totale: 0 }) - 1;
        //     let totOrd = 0;
        //     let listRig = await WS.Plus.getListaOrdineRighe(WS.UT.TOKEN, ord.Id);

        //     ordiniNew[posNew].righe = listRig.list;

        //     ordiniNew[posNew].righe.forEach(r => totOrd += r.Prezzo * r.Quantita);
        //     ordiniNew[posNew].totale = totOrd;
        // }

        // setOrdini(ordiniNew);
    }

    const passToModal = (ordine: WS.Plus.IF.AbbonamVendTest) => {
        WS.Plus.getAbbonamVendRighe(WS.UT.TOKEN, ordine.Id).then(r => {
            setOrdineSel({ testata: ordine, righe: r.list });
            setModalShow(true);
        });
        // setOrdiniSel(ordine)
    }

    useEffect(() => {
        onLoad();
    }, []);

    useEffect(() => {
        if (filSedeSel == undefined)
            setSedi(undefined)
        else
            WS.Plus.getListaAbbonamVend(WS.UT.TOKEN, 0, '', '', '', '', 0, 0, 0, parseInt(filSedeSel), '', 0, 0, 0).then(r => setOrdini(r.list))


    }, [filSedeSel]);

    const modalBody = (): JSX.Element =>
        <>
        </>


    return (
        <Screen>
            <div className='container'>
                <div className='row'>
                    <div className='d-flex card flex-column flex-md-row mb-3' >
                        <h2>Ordini</h2>
                        <div className='ms-md-auto'>
                            <ActionBtn
                                modello='Ordini'
                                add={false}
                                del={false}
                                // onDel={onMultipleDelete}
                                // modalOnSave={() => updateAbbonamenti(abbSel ?? WS.Plus.IF.AbbonamentoInit())}
                                // modalOnClose={() => clearForm()}
                                modalBody={modalBody()}
                                // onNew={clearForm}
                                sedi={sedi}
                                sedeSel={filSedeSel}
                                setSedeSel={setFilSedeSel}
                            />
                        </div>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12 card'>
                        <table className="table">
                            <thead>
                                {isMobile ?
                                    <></>
                                    :
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">Cliente</th>
                                        <th scope="col">Data</th>
                                        <th scope="col">Totale</th>
                                    </tr>
                                }
                            </thead>
                            <tbody>
                                {ordini ?
                                    ordini.map((ordine, o) =>
                                        isMobile ?
                                        <TableOrdini ordine={ordine} passToModal={() => passToModal(ordine)} />
                                        :
                                        <tr className='pointer' key={o} onClick={() => passToModal(ordine)}>
                                            <th scope="row">{ordine.Id}</th>
                                            <td>{ordine.desCliente}</td>
                                            <td>{UT.dateWStoDateStr(ordine.DataAbb)}</td>
                                            <td>{ordine.Prezzo.toFixed(2)}</td>
                                        </tr>
                                    )
                                    :
                                    <Spinner />
                                }
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>

            <Modal
                isShow={modalShow}
                onClose={() => setModalShow(false)}
                title={"Ordine " + ordineSel?.testata.Id}
                body={
                    <>
                        <div className='row'>
                            <div className='col-12 col-md-6 mb-3'>
                                <label>Data</label>
                                <input className="form-control " type="text" value={UT.dateWStoDateStr(ordineSel?.testata.DataAbb)} readOnly />
                            </div>
                            <div className='col-12 col-md-6 mb-3'>
                                <label>Numero</label>
                                <input className="form-control " type="text" value={ordineSel?.testata.Numero.toString()} readOnly />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-12 col-md-6 mb-3'>
                                <label>Cliente</label>
                                <input className="form-control " type="text" value={ordineSel?.testata.desCliente} readOnly />
                            </div>
                            <div className='col-12 col-md-6 mb-3'>
                                <label>Stato</label>
                                <input className="form-control " type="text" value={WS.Plus.IF.StatoAbbVen[ordineSel?.testata.Stato ?? 0]} readOnly />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-12 col-md-6 mb-3'>
                                <label>Abbonamento</label>
                                <input className="form-control " type="text" value={ordineSel?.testata.desAbbonamento} readOnly />
                            </div>
                            <div className='col-12 col-md-6 mb-3'>
                                <label>Ingressi usati</label>
                                <input className="form-control " type="text" value={ordineSel?.testata.Contatore} readOnly />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-12 col-md-6 mb-3'>
                                <label>Prezzo</label>
                                <input className="form-control " type="text" value={ordineSel?.testata.Prezzo.toFixed(2)} readOnly />
                            </div>
                            <div className='col-12 col-md-6 mb-3'>
                                <label>Sconto %</label>
                                <input className="form-control " type="text" value={ordineSel?.testata.Sconto} readOnly />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-12 col-md-6 mb-3'>
                                <label>Tipo abbonamento</label>
                                <input className="form-control " type="text" value={WS.Plus.IF.TipoAbbonamento[ordineSel?.testata.tipoAbb ?? 0]} readOnly />
                            </div>
                            <div className='col-12 col-md-6 mb-3'>
                                <label>Data scadenza</label>
                                <input className="form-control " type="text" value={UT.dateWStoDateStr(ordineSel?.testata.DataSca)} readOnly />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-12 card'>
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th scope="col"> </th>
                                            <th scope="col">Articoli</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {ordineSel &&
                                            ordineSel.righe.map((riga, o) =>
                                                <tr key={o}>
                                                    <th scope="row">{riga.IdRiga}</th>
                                                    <td>{riga.DescrRiga}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </>
                }
            />
        </Screen>
    );
}

